export const MonopolioIcoSvg = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.539551 6.63888L7.03908 0.143066H14.9516L8.45203 6.63888H15.4602L8.45203 13.6431H1.44383L8.45203 6.63888H0.539551Z"
      fill="url(#paint0_linear_12982_4672)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12982_4672"
        x1="6.95637"
        y1="-0.440621"
        x2="11.54"
        y2="12.8516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0368FE" />
        <stop offset="1" stop-color="#00FFF0" />
      </linearGradient>
    </defs>
  </svg>
)
export default MonopolioIcoSvg
